import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	Tooltip,
	TooltipTrigger,
	TooltipContent,
	TooltipProvider,
} from 'components/ui/tooltip'
import { ListPlus, ListTodo } from 'lucide-react'
import Popup from 'components/Popup'
import Spinner from 'components/Spinner'
import Message from 'components/Message'
import TemplateTaskPopup from 'components/popups/TemplateTaskPopup'
import TemplateAddEdit from 'components/TemplateAddEdit'
import TemplateTask from './TemplateTask'
import {
	createTemplateTask,
	initializeTemplateTasks,
	initializeTemplates,
	updateTemplate,
	updateTemplateTask,
} from 'slices/templateSlice'

const TaskTemplateFeed = ({ taskTemplate }) => {
	const dispatch = useDispatch()

	const templateId = taskTemplate._id

	const [openPopup, setOpenPopup] = useState(false)
	const [openEditTemplatePopup, setOpenEditTemplatePopup] = useState(false)
	const [popupTitle, setPopupTitle] = useState('Update Task')
	const [recordForEdit, setRecordForEdit] = useState(null)

	const {
		entities: taskEntities,
		ids: taskIds,
		isInitialized: tasksInitialized,
		isLoading: tasksLoading,
		error,
	} = useSelector(state => state.templates.tasks)
	const newTasks = taskIds.map(id => taskEntities[id])

	const tasks = newTasks
	const taskSeq = tasks.length + 1

	const userLogin = useSelector(state => state.userLogin)
	const { userInfo: user } = userLogin

	const userId = user._id

	useEffect(() => {
		dispatch(initializeTemplateTasks(templateId))
	}, [dispatch, templateId])

	const openInPopup = task => {
		setRecordForEdit(task)
		setOpenEditTemplatePopup(true)
	}

	const addEditTask = async (task, resetForm) => {
		const taskName = task.taskName
		const seq = task.seq
		const taskDays = task.taskDays
		const description = task.description

		if (task._id === 0) {
			dispatch(
				createTemplateTask({
					templateId: templateId,
	taskName: taskName,
					seq: seq,
					taskDays: taskDays,
					description: description,
				}),
			)
			dispatch(initializeTemplateTasks(templateId))
		} else {
			dispatch(
				updateTemplateTask({
					_id: task._id,
					templateId: templateId,
	taskName: taskName,
					seq: seq,
					description: description,
				}),
			)
		}

		resetForm()
		setOpenPopup(false)
		setRecordForEdit(null)
		await dispatch(initializeTemplateTasks(templateId))
	}

	const handleUpdateTemplate = async (template, resetForm) => {
		const templateName = template.templateName
		const description = template.description
		const templateType = template.templateType

		await dispatch(
			updateTemplate({
				_id: templateId,
				createdBy: userId,
				templateName: templateName,
				description: description,
				templateType: templateType,
			}),
		)

		resetForm()
		setRecordForEdit(null)
		setOpenEditTemplatePopup(false)
		await dispatch(initializeTemplates())
	}

	return (
		<div>
			<div className="task">
				<div className="task__header">
					<div className="task__info">
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<h2
										className="cursor-pointer"
										onClick={() => {
											setPopupTitle('Update')
											openInPopup(taskTemplate)
										}}
									>
										{taskTemplate.templateName}
									</h2>
								</TooltipTrigger>
								<TooltipContent>{taskTemplate.description}</TooltipContent>
							</Tooltip>
						</TooltipProvider>
					</div>
					<div className="task__button">
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<button
										type="button"
										className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors text-blue-600"
										onClick={() => {
											setPopupTitle(`New Task`)
											setRecordForEdit(null)
											setOpenPopup(true)
										}}
									>
										<ListPlus className="w-4 h-4" />
									</button>
								</TooltipTrigger>
								<TooltipContent>Add new Task.</TooltipContent>
							</Tooltip>
						</TooltipProvider>
					</div>
				</div>
			</div>
			<div className="taskFeed_Container">
				{tasksLoading ? (
					<Spinner />
				) : error ? (
					<Message variant="danger">{error}</Message>
				) : tasks.length > 0 ? (
					<div>
						{tasks.map(task => (
							<TemplateTask key={task._id} templateTask={task} />
						))}
					</div>
				) : null}

				{openPopup && (
					<Popup title={popupTitle} openPopup={openPopup} setOpenPopup={setOpenPopup} icon={<ListTodo className="w-5 h-5" />} description="Edit task details">
						<TemplateTaskPopup
							recordForEdit={recordForEdit}
							addEditTask={addEditTask}
							taskSeq={taskSeq}
						/>
					</Popup>
				)}
				{openEditTemplatePopup && (
					<Popup
						title={popupTitle}
						openPopup={openEditTemplatePopup}
						setOpenPopup={setOpenEditTemplatePopup}
						icon={<ListTodo className="w-5 h-5" />}
						description="Edit template details"
					>
						<TemplateAddEdit
							recordForEdit={recordForEdit}
							handleSubmit={handleUpdateTemplate}
							// taskSeq={taskSeq}
						/>
					</Popup>
				)}
			</div>
		</div>
	)
}

export default TaskTemplateFeed
